import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './shared/guards/auth.guard';

import { ActionsComponent } from './pages/actions/actions.component';
import { ProjectsComponent } from './pages/projects/projects.component';
import { EntranceComponent } from './pages/entrance/entrance.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { EntitiesComponent } from './pages/entities/entities.component';

const routes: Routes = [
  {
    path: '',
    component: ActionsComponent,
    canActivate: [ AuthGuard ],
  },
  {
    path: 'projects',
    component: ProjectsComponent,
    canActivate: [ AuthGuard ],
  },
  {
    path: 'entrance',
    component: EntranceComponent,
  },
  {
    path: 'entities',
    component: EntitiesComponent,
    canActivate: [ AuthGuard ],
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [ AuthGuard ],
  },
];
export const AppRouterModule = RouterModule.forRoot(routes);



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/app.routes.ts